import { render, staticRenderFns } from "./osNaoExec.vue?vue&type=template&id=c5b061d6&scoped=true"
import script from "./osNaoExec.vue?vue&type=script&lang=js"
export * from "./osNaoExec.vue?vue&type=script&lang=js"
import style0 from "./osNaoExec.vue?vue&type=style&index=0&id=c5b061d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b061d6",
  null
  
)

export default component.exports